export const enumValues = <T extends Record<string, string>>(e: T) =>
  Object.values(e) as Array<T[keyof T]>;
